<template>
  <div id="studentForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <div class="text-center text-h5" v-if="sibling">
        Sibling: {{sibling.firstName}} {{sibling.lastName}}
      </div>
      <v-select label="Center" v-model="selectedCenterId" :items="availableCenters" item-text="name" item-value="id"/>
      <v-select v-if="contactTypes && contactTypes.length > 1" label="Type" v-model="selectedTypeId" :items="contactTypes" item-text="name" item-value="id"/>
      <v-text-field
        v-model="student.firstName"
        label="First Name"
        :required="true"
      />
      <v-text-field
        v-model="student.lastName"
        label="Last Name"
        :required="true"
      />

      <date-picker
        label="Date of Birth"
        :show-icon="false"
        v-model="student.dob"
        :defaultNowOnNull="false"
        clearable
      />

      <v-text-field
        v-model="student.clientStudentId"
        label="Student ID"
        :required="true"
      />

      <v-select
        v-model="student.gender"
        :items="student.relations.gender"
        label="Gender"
        chips
        deletable-chips
      ></v-select>

      <v-select
        v-model="student.grade"
        :items="student.relations.grade"
        label="Grade"
        chips
        deletable-chips
      ></v-select>

      <v-textarea label="Memo" v-model="student.memo" outlined :rows="2" auto-grow/>

      <v-switch v-model="student.active" label="Active"/>

      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import { getStudent } from "@/services/student";
import { getAllContactTypes } from "@/services/contactType";

import { mapActions } from "vuex";

export default {
  props: ["id", "siblingId"],
  data() {
    return {
      loaded: false,
      valid: false,
      contactTypes: [],
      selectedCenterId: null,
      selectedTypeId: null,
      sibling: null,
      student: {
        relations: {
          gender: ["Female", "Male"],
          grade: ["Nursery", "3K", "Pre-K", "Kindergarten"]
        },
        firstName: "",
        lastName: "",
        gender: "",
        grade: "",
        dob: "",
        memo: "",
        clientStudentId: '',
        active: null,
        contactId: null,
        centerId: null,
        contactTypeId: null,
      }
    };
  },
  created() {
    this.setInstance();

    if(this.siblingId){
      this.initSibling();
    }
  },
  computed: {
    ...mapGetters("auth", ["myCenters"]),
    ...mapGetters("navigation", ["globalCenter"]),
    availableCenters(){
      if(this.myCenters && this.myCenters.length > 0){
        return this.myCenters.filter(c => c.id != null);
      }
      else{ return [] }
    }
  },
  methods: {
    ...mapActions("student", ["createStudent", "updateStudent"]),
    ...mapActions("grade", ["deleteGrade", "fetchGrades"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),

    async handleSubmit() {
      this.student.centerId = this.selectedCenterId;
      this.student.contactTypeId = this.selectedTypeId;
      // Ensure active is explicitly true or false, not null
      this.student.active = this.student.active === true ? true : false;
      let student = this.student;
      delete student.relations;

      if (this.id) {
        this.updateStudent(student)
          .then(response => {
            console.log(response);
            this.addSuccessMessage("Student was updated successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error updating Student, please try again later"
            );
          });
      } else {
        if(this.sibling){
          student.contactId = this.sibling.contactId;
        }

        if(!student.contactTypeId && this.contactTypes.length > 0){
          student.contactTypeId = this.contactTypes[0].id;
        }

        this.createStudent(student)
          .then(response => {
            console.log(response);
            this.addSuccessMessage("Student was created successfully");
            this.goBack();
          })
          .catch( (error) => {
              const resp = error.data;
              if(resp.code == 'RECORD_ALREADY_EXIST'){
                  this.addErrorMessage(resp.message || "Student already existed")
              }
              else{
                  this.addErrorMessage(resp.message || "Error saving student")
              }
          })
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    setInstance() {
      if (this.id) {
        this.student.id = this.id;
        getStudent(this.id).then(response => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.student, property)
            ) {
              this.student[property] = instance[property];
            }
          }

          this.selectedCenterId = this.student.centerId;
          this.selectedTypeId = this.student.contactTypeId;
          this.loaded = true;

          this.$emit('input', this.student)
        });
      } else {
        //set selected Center
        if(this.globalCenter){
          this.selectedCenterId = this.globalCenter.id;
        }
        this.loaded = true;
      }
      this.setDependencies();
    },
    initSibling() {
      if (this.siblingId) {
        getStudent(this.siblingId).then(response => {
          this.sibling = response.data;
        });
      }
    },
    setDependencies() {
      const params = {
        page: 0,
        size: 100
      };
      getAllContactTypes(params).then(response => {
        const allTypes = response.data.content;
        //filter all contact type that has student
        this.contactTypes = allTypes.filter(type => type.has_student);
        // if(this.contactTypes && this.contactTypes.length > 0){
        //   this.selectedTypeId = this.contactTypes[0].id;
        // }
      });

      this.fetchGrades(params)
        .then((response) => {
          if (response) {
            const grades = response.content;
            if(grades && grades.length > 0){
              this.student.relations.grade = grades.map(g => g.name);
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.addErrorMessage("Error retrieving grades");
        });
      
    }
  },
  components: {
  }
};
</script>
